/**
 * Per-user UI preferences that follow the user across devices (stored on the user via /v1/me, not
 * in the browser): dashboard widget visibility, messaging sound, muted threads. `save` merges a
 * patch into the current settings, PATCHes /me, and refetches so the new value propagates.
 */
import { useIdentityUpdateMe } from '@oex/contracts';
import { useSession } from './session';

export type UiSettings = {
  dashboardHiddenWidgets?: string[];
  messagingSound?: boolean;
  mutedThreadIds?: string[];
};

export function useUiSettings() {
  const { me, refresh } = useSession();
  const update = useIdentityUpdateMe();
  const settings = (me?.user.uiSettings ?? {}) as UiSettings;
  const save = async (patch: Partial<UiSettings>) => {
    const next: UiSettings = { ...settings, ...patch };
    await update.mutateAsync({ data: { uiSettings: next } });
    await refresh();
  };
  return { settings, save, saving: update.isPending };
}
